module.exports = __webpack_public_path__ + "wf.svg?24ed7b24a80bfb00cb3fb6e2c5ce4ef6";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/wf.svg
// module id = 976
// module chunks = 27